import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import axios from "axios";
import moment from "moment";
import { Button, Modal, Table, Row, Col } from "react-bootstrap";
const PackerMoversVehicle = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const useQueryParams = () => {
    return new URLSearchParams(search); // Parse the query string
  };

  const queryParams = useQueryParams();

  // Fetch query parameters
  const service = queryParams.get("service");
  const city = queryParams.get("city");
  const shiftingFrom = queryParams.get("shiftingFrom");
  const shiftingTo = queryParams.get("shiftingTo");
  const lat = queryParams.get("lat");
  const lang = queryParams.get("lang");
  const latto = queryParams.get("latto");
  const langto = queryParams.get("langto");

  const [show, setShow] = useState(false);
  const [editid, seteditid] = useState("");
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [Distance,setDistance]=useState(0);
  const currenttime = new Date();
  const [time, setTime] = useState(moment().format("HH:MM"));
  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);


  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState({});

  const handleSelect = (id) => {
    setSelectedVehicle(id);
  };
  const getVehicle = async () => {
    try {
      let res = await axios.get("https://vrpmpro.com/api/admin/vehicle-types");
      if (res.status == 200) {
        setVehicleTypes(res.data.vehicleTypes)
        handleSelect(res.data.vehicleTypes[0])
      }
    } catch (error) {
      console.log(error);

    }
  }

  useEffect(() => {
    getVehicle();
  }, []);


  const apiKey = "AIzaSyClbig43rDJiDAjE8QVefX2LNZpczeBt5w"; // Google Maps API key

  // Function to fetch coordinates using Google Maps Geocoding API
  const fetchCoordinates = async (address) => {
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${apiKey}`;
    try {
      const response = await fetch(url);
      const data = await response.json();
      if (data.results && data.results.length > 0) {
        const location = data.results[0].geometry.location;
        return { lat: location.lat, lng: location.lng }; // Return { lat, lng }
      } else {
        console.error("No results found for address:", address);
        return null;
      }
    } catch (error) {
      console.error("Error fetching coordinates:", error);
      return null;
    }
  };

  useEffect(() => {
    const initializeMap = async () => {
      const fromCoords = await fetchCoordinates(shiftingFrom);
      const toCoords = await fetchCoordinates(shiftingTo);

      if (fromCoords && toCoords) {
        const map = L.map("map").setView([fromCoords.lat, fromCoords.lng], 13);

        // Add OpenStreetMap tiles
        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
          attribution:
            '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        }).addTo(map);

        // Define a custom icon
        const customIcon = L.icon({
          iconUrl: "/img/location2.png", // Path relative to public folder
          iconSize: [32, 32],
          iconAnchor: [16, 32],
          popupAnchor: [0, -32],
        });

        // Add markers with the custom icon for both locations
        const fromMarker = L.marker([fromCoords.lat, fromCoords.lng], { icon: customIcon })
          .addTo(map)
          .bindPopup(`<b>From:</b> ${shiftingFrom}`)
          .openPopup();

        const toMarker = L.marker([toCoords.lat, toCoords.lng], { icon: customIcon })
          .addTo(map)
          .bindPopup(`<b>To:</b> ${shiftingTo}`);

        // Add a polyline (line) between the two locations
        const latlngs = [
          [fromCoords.lat, fromCoords.lng],
          [toCoords.lat, toCoords.lng],
        ];
        const polyline = L.polyline(latlngs, { color: "blue", weight: 4 }).addTo(map);

        // Fit the map to show both markers and the polyline
        map.fitBounds(polyline.getBounds());
      } else {
        console.error("Unable to fetch coordinates for the locations");
      }
    };

    initializeMap();
  }, [shiftingFrom, shiftingTo]);

const handleResh=(e)=>{
  e.preventDefault();
  handleClose()
  alert("Successfully Apply");

}

const user=JSON.parse(sessionStorage.getItem("user"))
const [selectedPayment, setSelectedPayment] = useState("");
const [showp,setShowp]=useState(false);
const handaleSend=async(e)=>{
  e.preventDefault();
  try {
   
      const config = {
        url: "/user/bookings",
        method: "post",
        baseURL: "https://vrpmpro.com/api",
        headers: { "content-type": "application/json" },
        data: { customerName:user?.name,
          phone:user?.phonenumber,
          email:user?.email,
          pickupAddress:shiftingFrom,
          deliveryAddress:shiftingTo,
          bookingDate:date,
          vehicleType:selectedVehicle?.typeName,
          totalPrice: (() => { const subtotal = (selectedVehicle?.price || 0) + ((selectedVehicle?.perkmprice || 0) * Distance); return parseFloat((subtotal + (subtotal * (selectedVehicle?.gst || 0) / 100)).toFixed(2)); })(),
          //    pickupLat:,
          // pickupLng,
          // deliveryLat,
          // deliveryLng,
          city:city,
          bookingTime:time,
          setviceType:service,
        },
      };
      let res = await axios(config);
      if (res.status === 201) {
        alert("Successfully booked");
       return window.location.assign("/")
       


      }
  } catch (error) {
    console.log(error);
    
  }
}
const placeOrder=()=>{
  if(!user) return alert("Please Login!")
  if(!shiftingFrom) return alert("Please selct your from locateion");
  if(!shiftingTo) return alert("Please select your to location");
  if(Object.keys(selectedVehicle).length==0) return alert("Please selcet vehicle");
 return setShowp(true)
}


const calculateRouteDistance = async (coords1, coords2) => {
  const url = `https://router.project-osrm.org/route/v1/driving/${coords1.lon},${coords1.lat};${coords2.lon},${coords2.lat}?overview=false`;
  try {
    const response = await axios.get(url);
    const distanceInMeters = response.data.routes[0].distance;
    setDistance((distanceInMeters / 1000).toFixed(2)); // Convert to kilometers
  } catch (error) {
    console.error("Error calculating route distance:", error);
    // setDistance("Error calculating distance.");
  }
};

useEffect(()=>{
  if(lat&&lang&&langto&&latto){
    calculateRouteDistance({lat:lat,lon:lang},{lat:latto,lon:langto})
  }
 
},[lat,lang,langto,latto])

console.log("distance",Distance);

  return (
    <div className="container-fluid" style={{ background: "#E2E1E1", paddingBottom: "100px" }}>
      <div className="row">
        <div className="col-md-8">
          <div className="card mt-3">
            <div className="card-body">
              {/* Map container */}
              <div id="map" style={{ height: "400px", width: "100%" }}></div>
            </div>
          </div>

          <Card className="vehicle-selection mt-3">
            <h5>Select Vehicle</h5>
            <div className="row">
              {vehicleTypes.map((vehicle) => (
                <div
                  key={vehicle._id}
                  className={`col-md-4`}
                  onClick={() => handleSelect(vehicle)}
                >
                  <div className={`card ${selectedVehicle?._id == vehicle._id ? "selected" : ""}`}>
                    <div className="card-body">
                      <img
                        alt={vehicle?.typeName}
                        height="100"
                        src={`https://vrpmpro.com/vehicletypes/${vehicle?.typeImage}`}
                        width="100"
                      />
                      <h5>{vehicle?.typeName}</h5>
                      <p>{vehicle?.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="row mt-3">
              <div className="col-md-6">
                <button className="btn bg-success text-white" onClick={handleShow}>Schedule</button>
              </div>
              <div className="col-md-6">
                <button className="btn btn-danger" onClick={placeOrder}>Book Now</button>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-12 text-end">
                <p className="total">Total: ₹ {(() => { const subtotal = (selectedVehicle?.price || 0) + ((selectedVehicle?.perkmprice || 0) * Distance); return (subtotal + (subtotal * (selectedVehicle?.gst || 0) / 100)).toFixed(2); })()}</p>
              </div>
            </div>
          </Card>
        </div>

        <div className="col-md-4 ">
          <div className="position-fixed top-4" style={{ zIndex: 1 }}>
            <div className="booking-details mt-3">
              <div className="card">
                <div className="card-body">
                  <h5>Booking Details</h5>
                  <div className="d-flex align-items-center mb-3">
                    <i className="fas fa-map-marker-alt text-success me-2"></i>
                    <div>
                      <h6>{shiftingFrom?.slice(0, 10)}</h6>
                      <p>{shiftingFrom}</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center">
                    <i className="fas fa-map-marker-alt text-danger me-2"></i>
                    <div>
                      <h6>{shiftingTo?.slice(0, 10)}</h6>
                      <p>{shiftingTo}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Schedule Date & Time</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div class="container mt-2">
            <form onSubmit={handleResh}>

              <div class="mb-3">
                <label for="date" class="form-label">Date</label>
                <input
                  type="date"
                  class="form-control"
                  id="date"
                  value={date}
                  min={new Date().toISOString().split("T")[0]}
                  required
                  onChange={(e) => setDate(e.target.value)}
                />
              </div>
              <div class="mb-3">
                <label for="time" class="form-label">Time</label>
                <input
                  type="time"
                  class="form-control"
                  id="time"
                  value={time}

                  required
                  onChange={(e) => setTime(e.target.value)}
                />
              </div>


              <div className="d-flex justify-content-between">
                <button type="submit" class="btn btn-outline-success">Submit</button>
                <p className="total">Total: ₹ {(() => { const subtotal = (selectedVehicle?.price || 0) + ((selectedVehicle?.perkmprice || 0) * Distance); return (subtotal + (subtotal * (selectedVehicle?.gst || 0) / 100)).toFixed(2); })()}</p>
              </div>

            </form>
          </div>


        </Modal.Body>
       
      </Modal>

      <Modal show={showp} onHide={()=>setShowp(false)}  size="sm">
        <Modal.Header closeButton>
          <Modal.Title>Payment Method</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form onSubmit={handaleSend}>
            <div className="modal-body d-flex justify-content-between">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="paymentMethod"
                  id="cashOption"
                  value="Cash"
                  checked={selectedPayment === "Cash"}
                  onChange={(e) => setSelectedPayment(e.target.value)}
                />
                <label className="form-check-label" htmlFor="cashOption">
                  Cash
                </label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="paymentMethod"
                  id="onlineOption"
                  value="Online"
                  checked={selectedPayment === "Online"}
                  onChange={(e) => setSelectedPayment(e.target.value)}
                />
                <label className="form-check-label" htmlFor="onlineOption">
                  Online
                </label>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={()=>setShowp(false)}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-outline-success"
                disabled={!selectedPayment}
              >
                Confirm
              </button>
            </div>
          </form>
        </Modal.Body>
       
      </Modal>
    </div>
  );
};

export default PackerMoversVehicle;
